import React, { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import "../../styles/sidebar.css";
import logo from "../../assets/dr-is-in.png";
import auraLogo from "../../assets/aura.jpg";

const Sidebar: React.FC = () => {
  const navigate = useNavigate();
  const year = new Date().getFullYear();
  const [auraImgError, setAuraImgError] = useState(false);

  const handleLogout = () => {
    const keys = [
      "admin_access_token",
      "admin_token",
      "doctor_access_token",
      "doctor_token",
      "student_access_token",
      "student_token",
      "pt_access_token",
      "pt_token",
      "parent_teacher_access_token",
      "parent_teacher_token",
      "school_access_token",
      "school_token",
      "access_token",
      "token",
      "role",
      "doctor_id",
      "student_id",
      "student_pk",
      "admin_id",
      "pt_id",
      "parent_teacher_id",
      "school_id",
      "org_id",
    ];

    [sessionStorage, localStorage].forEach((store) => {
      keys.forEach((k) => {
        try {
          store.removeItem(k);
        } catch {}
      });
    });

    navigate("/");
  };

  const linkClass = ({ isActive }: { isActive: boolean }) =>
    `sidebar-link ${isActive ? "active" : ""}`;

  return (
    <aside className="sidebar">
      <div className="sidebar-header">
        <img className="sidebar-logo" src={logo} alt="Doctor Is In" />
        <div className="sidebar-title-group">
          <h1 className="sidebar-title">Doctor Is In</h1>
          <div className="app-tagline">AI Wellness Advisor with a human touch.</div>
        </div>
      </div>

      <nav className="sidebar-nav">
        <NavLink to="/dashboard" className={linkClass}>
          Dashboard
        </NavLink>

        <NavLink to="/add-doctor" className={linkClass}>
          Add Advisor
        </NavLink>

        <NavLink to="/bulk-upload" className={linkClass}>
          Bulk Upload
        </NavLink>

        <NavLink to="/admin/org-roster" className={linkClass}>
          Org Roster / Users
        </NavLink>


        <NavLink to="/admin/doctor-roster" className={linkClass}>
          Advisor Roster (PINs)
        </NavLink>

        <NavLink to="/admin/tips" className={linkClass}>
          Tips Gallery
        </NavLink>

        <NavLink to="/admin/avatar-gallery" className={linkClass}>
          Avatar Gallery
        </NavLink>

        <NavLink to="/admin/contact-inbox" className={linkClass}>
          Contact Inbox
        </NavLink>

        <NavLink to="/admin/analytics" className={linkClass}>
          Analytics
        </NavLink>

        <NavLink
          to="/admin/aura"
          style={({ isActive }) => ({
            display: "block",
            marginTop: 16,
            textDecoration: "none",
            borderRadius: 18,
            padding: 12,
            background: isActive
              ? "linear-gradient(180deg, rgba(255,255,255,0.14) 0%, rgba(95,215,255,0.12) 100%)"
              : "linear-gradient(180deg, rgba(255,255,255,0.08) 0%, rgba(255,255,255,0.04) 100%)",
            border: isActive
              ? "1px solid rgba(95,215,255,0.72)"
              : "1px solid rgba(255,255,255,0.14)",
            boxShadow: isActive
              ? "0 0 0 1px rgba(95,215,255,0.18), 0 14px 28px rgba(0,0,0,0.26)"
              : "0 10px 22px rgba(0,0,0,0.18)",
          })}
        >
          {({ isActive }) => (
            <div>
              <div
                style={{
                  width: "100%",
                  height: 70,
                  borderRadius: 14,
                  background: "#ffffff",
                  boxShadow: "0 6px 14px rgba(0,0,0,0.28), inset 0 1px 0 rgba(255,255,255,0.8)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  overflow: "hidden",
                }}
              >
                {!auraImgError ? (
                  <img
                    src={auraLogo}
                    alt="AURA"
                    style={{
                      maxWidth: "92%",
                      maxHeight: "86%",
                      objectFit: "contain",
                      display: "block",
                    }}
                    onError={() => setAuraImgError(true)}
                  />
                ) : (
                  <div
                    style={{
                      fontWeight: 900,
                      fontSize: 20,
                      color: "#0b2140",
                      letterSpacing: "0.04em",
                    }}
                  >
                    AURA
                  </div>
                )}
              </div>

              <div
                style={{
                  marginTop: 10,
                  textAlign: "center",
                  fontSize: 16,
                  fontWeight: 900,
                  letterSpacing: "0.03em",
                  color: "#ffffff",
                  lineHeight: 1.1,
                }}
              >
                AURA
              </div>

              <div
                style={{
                  marginTop: 4,
                  textAlign: "center",
                  fontSize: 12,
                  fontWeight: 800,
                  color: isActive ? "#baf3ff" : "#7fe7ff",
                  lineHeight: 1.2,
                }}
              >
                Emotional Forecast
              </div>
            </div>
          )}
        </NavLink>
      </nav>

      <div className="sidebar-spacer" />

      <button className="logout-btn" onClick={handleLogout}>
        Logout
      </button>

      <div className="sidebar-footer">© {year} Doctor Is In App. All rights reserved.</div>
    </aside>
  );
};

export default Sidebar;